module.exports = __webpack_public_path__ + "img/porto-logo-icon.fe7e3cfb.png";